export default angular.module('syInputPrivacy', [])
    /**
     * @ngdoc controller
     * @name inputPrivacy.controller:inputPrivacy
     * @description
     * Scope to control the privacy of a single input
     */
    // @ngInject
    .controller('InputPrivacyController', function () {
        var controllerInputType = 'text';
        this.isPrivate = false;
        this.setInputType = function (inputType) {
            controllerInputType = inputType;
        };
        this.getInputType = function () {
            return this.isPrivate ? 'password' : controllerInputType;
        };
        this.togglePrivacy = function (override) {
            this.isPrivate = typeof override === 'boolean' ?
                override : !this.isPrivate;
        };
    })
    /**
     * @ngdoc directive
     * @name inputPrivacy.directive:inputPrivacy
     * @restrict A
     * @description
     * The form-group to track the privacy state
     */
    // @ngInject
    .directive('syInputPrivacy', function () {
        return {
            scope: true,
            restrict: 'A',
            controller: 'InputPrivacyController',
            controllerAs: 'inputPrivacyController',
            link: function ($scope, $element, attrs, controller) {
                if ('syInputPrivacyType' in attrs) {
                    controller.setInputType(attrs.syInputPrivacyType);
                }
                $scope.$watch(function () {
                    return controller.isPrivate;
                }, function (isPrivate) {
                    $element.toggleClass('form-input--private', isPrivate);
                });
            }
        };
    })
    /**
     * @ngdoc directive
     * @name inputPrivacy.directive:passwordToggle
     * @restrict A
     * @description
     * Will toggle the privacy of the current group
     */
    // @ngInject
    .directive('syPasswordToggle', function () {
        return {
            restrict: 'A',
            require: '^syInputPrivacy',
            link: function ($scope, $element, attrs, controller) {
                $element.on('click', function (e) {
                    e.preventDefault();
                    controller.togglePrivacy();
                });
            }
        };
    });
